import { createFileRoute } from "@tanstack/react-router";
import { AdminDashboardShell } from "@/components/layout/AdminDashboardShell";
import { DashboardHomePage } from "@/features/dashboard-home";

export const Route = createFileRoute("/")({
  component: OverviewRoute,
});

function OverviewRoute() {
  return (
    <AdminDashboardShell>
      <DashboardHomePage />
    </AdminDashboardShell>
  );
}
